import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HelperService } from './helper.service';
import { NgKnifeModule } from 'ng-knife';

import { CookieServiceService } from './cookie-service.service';
import { CookieModule } from 'ngx-cookie';
import { UtilisService } from './utilis.service';
import { HomeComponent } from './home/home.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TokenInterceptorService } from './token-interceptor.service';
import { AuthGuard } from './helpers/auth.guard';
import { OTPComponent } from './otp/otp.component';
import { SolchangeComponent } from './solchange/solchange.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FedEPointURLComponent } from './fed-epoint-url/fed-epoint-url.component';
import { CryptojsTestComponent } from './cryptojs-test/cryptojs-test.component';



let appRoutes: Routes = [{
  path: 'Default',
  component: HomeComponent
},
{
  path: 'OTPValidate',
  component: OTPComponent
},
{
  path: 'EPointURL/hash',
  component: FedEPointURLComponent
},
{
  path: 'Crypto',
  component: CryptojsTestComponent
},
{
  path: 'Home',
  component: SolchangeComponent,
  canActivate: [AuthGuard]
},
{ path: '**', redirectTo: '/Default' }];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    OTPComponent,
    SolchangeComponent,
    FedEPointURLComponent,
    CryptojsTestComponent

  ],
  imports: [
    BrowserModule,
    CookieModule.forRoot(),
    RouterModule.forRoot(appRoutes, { useHash: true }),
    FormsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    BrowserAnimationsModule,
    NgKnifeModule,
    NgSelectModule        
  ],
  providers: [HelperService,
    CookieServiceService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    UtilisService
  ],
  exports: [
    RouterModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
